import $ from "../tools/Dom";

export default (el) => {
    const dom = $(el);

    const onClick = (item) => {
        if (window.innerWidth < 900) {
            item.setAttribute(
                "aria-expanded",
                `${!(item.getAttribute("aria-expanded") === "true")}`
            );
        }
    };

    const items = dom.find("[data-collapse]");
    items.each((item) => {
        item.addEventListener("click", () => onClick(item));
    });
};
